<div>
<div class="modal-header border-0 d-flex m-0">
  <h5 class="modal-title text-dark" *ngIf="!user">{{'userManagement.ADD USER' | translate}}</h5>
  <h5 class="modal-title text-dark" *ngIf="user">{{'userManagement.EDIT USER' | translate}}</h5>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x text-dark" viewBox="0 0 16 16">
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    </span>
  </button>
</div>

<div class="modal-body pr-0">
  <div>
    <form (submit)="handleAddUser()" [formGroup]="userForm">
        <div class="form-group row" *ngIf="!user">
            <label for="username" [ngClass]="hasError('username') ? 'text-danger' : ''"
              class="col-sm-4 col-form-label text-dark">{{'userManagement.Username' | translate}}<span class="text-star">*</span></label>
            <div class="col-sm-8">
              <input appAlphabetsWithdot [ngClass]="hasError('username') ? 'border-danger' : ''" type="text" name="username"
                formControlName="username" class="form-control" id="username"
                 placeholder="{{'userManagement.Enter Username' | translate}}">
              <app-show-errors fieldName="{{'userManagement.Username' | translate}}" [showError]="hasError('username')" [ctrl]="getCtrl('username')">
              </app-show-errors>
            </div>
          </div>
      <div class="form-group row">
        <label for="firstName" [ngClass]="hasError('firstName') ? 'text-danger' : ''"
          class="col-sm-4 col-form-label text-dark">{{'userManagement.First Name' | translate}}<span class="text-star">*</span></label>
        <div class="col-sm-8">
          <input type="text"  appAlphabetsOnly [ngClass]="hasError('firstName') ? 'border-danger' : ''" name="firstName"
            formControlName="firstName" class="form-control" id="firstName" 
            placeholder="{{'userManagement.Enter FirstName' | translate}}">
          <app-show-errors fieldName="{{'userManagement.First Name' | translate}}" [showError]="hasError('firstName')" [ctrl]="getCtrl('firstName')">
          </app-show-errors>
        </div>
      </div>
      <div class="form-group row">
        <label for="lastName" [ngClass]="hasError('lastName') ? 'text-danger' : ''"
          class="col-sm-4 col-form-label text-dark">{{'userManagement.Last Name' | translate}}</label>
        <div class="col-sm-8">
          <input appAlphabetsOnly [ngClass]="hasError('lastName') ? 'border-danger' : ''" type="text" name="lastName"
            formControlName="lastName" class="form-control" id="lastName" 
            placeholder="{{'userManagement.Enter Last Name' | translate}}">
          <app-show-errors fieldName="{{'userManagement.Last Name' | translate}}" [showError]="hasError('lastName')" [ctrl]="getCtrl('lastName')">
          </app-show-errors>
        </div>
      </div>
      <div class="form-group row">
        <label for="mobile" [ngClass]="hasError('mobile') ? 'text-danger' : ''" 
        class="col-sm-4 col-form-label text-dark">{{'userManagement.Mobile Number' | translate}}</label>
        <div class="col-sm-8">
          <input  type="text" [ngClass]="hasError('mobile') ? 'border-danger' : ''" name="mobile"
          formControlName="mobile" maxlength=10  class="form-control" id="mobile" placeholder="Enter Mobile" appDigitsOnly>
        <app-show-errors fieldName="Mobile Number" patternErrMsg=" should have 10 digits"
          [showError]="hasError('mobile')" [ctrl]="getCtrl('mobile')"></app-show-errors>
        </div>
      </div>
      <div class="form-group row">
        <label for="mail" [ngClass]="hasError('mail') ? 'text-danger' : ''"
          class="col-sm-4 col-form-label text-dark">{{'userManagement.Email' | translate}}<span class="text-star">*</span></label>
        <div class="col-sm-8">
          <input type="mail" [ngClass]="hasError('mail') ? 'border-danger' : ''" name="mail" formControlName="mail"
            class="form-control" id="mail" placeholder="{{'userManagement.Enter email' | translate}}">
          <app-show-errors fieldName="{{'userManagement.Email' | translate}}" patternErrMsg="{{'userManagement.should be valid' | translate}}" [showError]="hasError('mail')" [ctrl]="getCtrl('mail')"></app-show-errors>
        </div>
      </div>
      <div class="form-group row" *ngIf="!user">
        <label for="passwordHash" [ngClass]="hasError('passwordHash') ? 'text-danger' : ''"
          class="col-sm-4 col-form-labeltext-dark ">{{'userManagement.Password' | translate}}<span  data-toggle="tooltip" title="{{passwordtext}}" data-placement="bottom"><i class="fas fa-info-circle ml-2"></i></span><span class="text-star">*</span></label>
        <div class="col-sm-8">
          <input appNotAllowSpaces [(ngModel)]="UserData['password']" (input)="pswdValidate(UserData['password'],'password')" type="password" [ngClass]="hasError('passwordHash') ? 'border-danger' : ''" name="passwordHash"
            formControlName="passwordHash" class="form-control" id="passwordHash" 
            placeholder="{{'userManagement.Enter Password' | translate}}" autocomplete="off">
          <app-show-errors fieldName="{{'userManagement.Password' | translate}}" [showError]="hasError('passwordHash')" [ctrl]="getCtrl('passwordHash')"></app-show-errors>
          <span style="color:red" [hidden]="!showerrorpwd">{{'userManagement.Weak Password' | translate}}</span>
        </div>
      </div>
      <div class="form-group row" *ngIf="!user">
        <label for="confirmPassword" [ngClass]="hasError('confirmPassword') ? 'text-danger' : ''"
          class="col-sm-4 col-form-label text-dark">{{'userManagement.Confirm Password' | translate}}<span  data-toggle="tooltip" title="{{passwordtext}}" data-placement="bottom"><i class="fas fa-info-circle ml-2"></i></span><span class="text-star">*</span></label>
        <div class="col-sm-8">
          <input appNotAllowSpaces [(ngModel)]="UserData['confirmpassword']" (input)="pswdValidate(UserData['confirmpassword'],'confirm')" type="password" [ngClass]="hasError('confirmPassword') ? 'border-danger' : ''" name="confirmPassword"
            formControlName="confirmPassword" class="form-control" id="confirmPassword" 
            placeholder="{{'userManagement.Re-enter Password' | translate}}" autocomplete="off">
          <app-show-errors fieldName="{{'userManagement.Password' | translate}}" [showError]="hasError('confirmPassword')" [ctrl]="getCtrl('confirmPassword')"></app-show-errors>
          <span style="color:red" [hidden]="!showerrorcnpwd">{{'userManagement.Weak Password' | translate}}</span>
        </div>
      </div>
      <!-- <div class="form-group row">
        <label for="status" [ngClass]="hasError('status') ? 'text-danger' : ''" class="col-sm-4 col-form-label">
          Status</label>
        <div class="col-sm-8">
          <select name="status" id="status" [ngClass]="hasError('status') ? 'border-danger' : ''" formControlName="status" class="form-control">
            <option value="-1" disabled>Select Status</option>
            <option [value]="status.statusValue" *ngFor="let status of statusList;">{{ status.statusName }}</option>
          </select>
          <app-show-errors fieldName="Status" patternErrMsg="required" [showError]="hasError('status')"
            [ctrl]="getCtrl('status')"></app-show-errors>
        </div>
      </div> -->
      <div class="form-group row">
        <label for="role" [ngClass]="hasError('role') ? 'text-danger' : ''" class="col-sm-4 col-form-labeltext-dark ">
          {{'userManagement.role' | translate}}<span class="text-star">*</span></label>
        <div class="col-sm-8">
          <select name="role" id="role" [ngClass]="hasError('role') ? 'border-danger' : ''"
           (change)="roleChanged(userForm.value.role)" formControlName="role" class="form-control">
            <option value="null" default="true" disabled>{{'userManagement.Select Role' | translate}}</option>
            <option *ngFor="let role of userListRole;" [value]="role">{{role}}</option>
          </select>
          <app-show-errors fieldName="{{'userManagement.Select Role' | translate}}" patternErrMsg="{{'userManagement.required' | translate}}" [showError]="hasError('role')"
            [ctrl]="getCtrl('role')"></app-show-errors>
        </div>
      </div>
      <div class="form-group row" *ngIf="showStateDropdown">
        <label for="state" [ngClass]="hasError('stateId') ? 'text-danger' : ''" class="col-sm-4 col-form-labeltext-dark ">
          State<span class="text-star">*</span></label>
        <div class="col-sm-8">
          <select name="stateId" id="stateId" [ngClass]="hasError('stateId') ? 'border-danger' : ''"
            (change)="setLocation('STATE')" formControlName="stateId" class="form-control">
            <option value="null" default="true" disabled>Select State</option>
            <option [value]="location['uuid']" *ngFor="let location of stateList;">{{ location['name'] }}</option>
          </select>
          <app-show-errors fieldName="State" patternErrMsg="{{'userManagement.required' | translate}}" [showError]="hasError('stateId')"
            [ctrl]="getCtrl('stateId')"></app-show-errors>
        </div>
      </div>

      <div class="form-group row" *ngIf="currentLoggedInUserInfo['role'] == 'GEC_STATE_ADMIN'">
          <label for="stateName" [ngClass]="hasError('stateId') ? 'text-danger' : ''"
            class="col-sm-4 col-form-labeltext-dark ">State</label>
          <div class="col-sm-8">
            <input type="text" [ngClass]="hasError('stateName') ? 'border-danger' : ''" name="firstName"
              formControlName="stateName" class="form-control" id="stateName" placeholder="Enter State Name" [attr.disabled] = "true">
            <app-show-errors fieldName="State" [showError]="hasError('stateName')" [ctrl]="getCtrl('stateName')">
            </app-show-errors>
          </div>
        </div> 

      <!-- <div class="form-group row" *ngIf="currentLoggedInUserInfo['role'] == 'GEC_STATE_ADMIN'"> -->
        <div class="form-group row" *ngIf="showdistdrop"> 
        <label for="district" [ngClass]="hasError('locationId') ? 'text-danger' : ''"
          class="col-sm-4 col-form-labeltext-dark ">{{isBasin?"Basin" : "District"}}<span class="text-star">*</span></label>
        <div class="col-sm-8">
          <select name="locationId" id="locationId" [ngClass]="hasError('locationId') ? 'border-danger' : ''"
          (change)="setLocation('DISTRICT')" formControlName="locationId" class="form-control">
           <option value="null" default="true">Select District</option>
            <option [value]="loc['uuid']" *ngFor="let loc of locationList;">{{ loc['name'] }}</option>
          </select>
          <app-show-errors fieldName="District" patternErrMsg="{{'userManagement.required' | translate}}" [showError]="hasError('locationId')"
            [ctrl]="getCtrl('locationId')"></app-show-errors>
        </div>
      </div>

      <!-- <div class="form-group row" *ngIf="showLocations">
        <label for="secondary" [ngClass]="hasError('secondary') ? 'text-danger' : ''"
          class="col-sm-4 col-form-label">Secondary Location</label>
        <div class="col-sm-8">
          <select name="secondary" id="secondary" [ngClass]="hasError('secondary') ? 'border-danger' : ''"
            formControlName="secondary" class="form-control">
            <option value="-1" disabled>Select Secondary Location</option>
            <option value="-1">None</option>
            <option [value]="location.entityId" 
              *ngFor="let location of locations;">{{ location.entityName }}</option>
          </select>
          <app-show-errors fieldName="Role" patternErrMsg="required" [showError]="hasError('role')"
            [ctrl]="getCtrl('role')"></app-show-errors>
        </div>
      </div> -->

      <div class="form-group row">
        <label for="Submit" class="col-sm-4 col-form-labetext-darkl "></label>
        <div class="col-sm-8">
          <input type="submit" class="btn btn-info" [disabled]="!this.userForm.valid || showerrorpwd || showerrorcnpwd || !distctSelected" value="{{context | translate}} {{'userManagement.User' | translate}}">
        </div>
      </div>
    </form>
  </div>
</div>
</div>